
import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { FaChevronDown } from "react-icons/fa";



const Container = styled.div`
  width: 100%;
  max-width: 900px;
`;

const RequestCard = styled.div`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 1rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ProviderInfo =  styled.div`
  display: flex;
  flex-direction:column;
  align-items: flex-start;

  @media (max-width: 768px) {
     font-size: 12px;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  padding:10px;
  border: none;
  border-radius: 4px;
  color: white;
  background-color: ${(props) => props.bg || '#385963'};
  cursor: pointer;
  display:flex;
  align-items:center;

  @media (max-width: 768px) {
     font-size: 10px;
      padding:5px;
  }

`;

const CollapsibleContent = styled.div`
  background: #f9f9f9;
  padding: 1rem;
  margin-top: 10px;
  border-radius: 5px;

   @media (max-width: 768px) {
     font-size: 14px;
  }
`;

const PdfFileButtons = styled.div`
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
`;

const PdfPreview = styled.iframe`
  width: 100%;
  height: 400px;
  border: none;
  margin-top: 1rem;
`;


const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.75);
  display: ${(props) => (props.visible ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  z-index: 10000;
`;

const ModalContent = styled.div`
  width: 90vw;
  height: 90vh;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
`;

const PdfIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
`;


// FilePlaceTypeEnum
const RoleEnums = {
  RegisteredUser : 0 ,
  Provider : 1,
  Admin : 2,
  PreApprovedProvider : 3,
};


const ProviderRequests = () => {
  const { t } = useTranslation();
  const [providerRequests, setProviderRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedRequestId, setExpandedRequestId] = useState(null);
  const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);

  const tokenString = sessionStorage.getItem("token");
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [modalVisible, setModalVisible] = useState(false);
const [modalPdfUrl, setModalPdfUrl] = useState(null);

const openModal = (url) => {
  setModalPdfUrl(url);
  setModalVisible(true);
};

const closeModal = () => {
  setModalVisible(false);
  setModalPdfUrl(null);
};

  const preApprovedProle = 3 ;


useEffect(() => {
  const fetchRequests = async () => {
    const active = true;
    const role = RoleEnums.PreApprovedProvider;
    const requestBody = { role, active };

    try {
      const response = await fetch(`${BASE_URL}User/search`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${tokenString}`
        },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) throw new Error('Failed to fetch provider requests');

      const users = await response.json();

      // Extract files from providerProfile directly
      const usersWithFiles = await Promise.all(users.map(async (user) => {
        const profile = user.providerProfile;

        if (!profile || !profile.fileNames?.length) {
          return { ...user, pdfFiles: [] };
        }

        try {
          const fileRes = await fetch(`${BASE_URL}ProviderProfile/getFiles`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenString}`
            },
            body: JSON.stringify(profile.fileNames)
          });

          if (!fileRes.ok) throw new Error("Failed to fetch file contents");

          const files = await fileRes.json();

          const fileLinks = files.map(f => ({
            id: f.fileName,
            name: f.originalFileName || f.fileName || "Unnamed.pdf",
            url: `data:${f.mimeType};base64,${f.base64Content}`
          }));

          return { ...user, pdfFiles: fileLinks };
        } catch (err) {
          console.error(`Error fetching files for user ${user.id}:`, err);
          return { ...user, pdfFiles: [] };
        }
      }));

      setProviderRequests(usersWithFiles);
    } catch (error) {
      console.error("Error fetching provider requests:", error);
    } finally {
      setLoading(false);
    }
  };

  fetchRequests();
}, [BASE_URL, tokenString]);


  const approveProvider = async (id) => {
    try {

   const response = await fetch(`${BASE_URL}User/${id}/updateToProviderRole`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${tokenString}`,
          },
        });
     
        if (!response.ok) throw new Error('Failed to approve provider');
        setProviderRequests((prev) => prev.filter((user) => user.id !== id));

      setProviderRequests((prev) => prev.filter((user) => user.id !== id));
      if (expandedRequestId === id) {
        setExpandedRequestId(null);
        setSelectedPdfUrl(null);
      }
    } catch (error) {
      console.error("Error approving provider:", error);
    }
  };



  const deleteProvider = (id) => {
    setProviderRequests((prev) => prev.filter((user) => user.id !== id));
    if (expandedRequestId === id) {
      setExpandedRequestId(null);
      setSelectedPdfUrl(null);
    }
  };

  if (loading) return <div>{t("loading")}...</div>;

  return (
    <Container>
      {providerRequests.length === 0 ? (
        <p>{t("noPendingProviderRequests")}</p>
      ) : (
        providerRequests.map((user) => (
          <div key={user.id}>
            <RequestCard>
              <ProviderInfo>
                <div><strong>{user.name}</strong></div>
                <div>{user.email}</div>
              </ProviderInfo>
              <Actions>
                <Button bg="#4CAF50" onClick={() => approveProvider(user.id)}>
                  {t("approve")}
                </Button>
                <Button bg="#d9534f" onClick={() => deleteProvider(user.id)}>
                  {t("reject")}
                </Button>
                <Button
                  bg="#385963"
                  onClick={() => {
                    if (expandedRequestId === user.id) {
                      setExpandedRequestId(null);
                      setSelectedPdfUrl(null);
                    } else {
                      setExpandedRequestId(user.id);
                      setSelectedPdfUrl(user.pdfFiles?.[0]?.url || null);
                    }
                  }}
                >
                  {expandedRequestId === user.id ? t("details") : t("details")}
                  <FaChevronDown
                    style={{
                      marginLeft: "8px",
                      transition: "transform 0.3s",
                      transform:
                        expandedRequestId === user.id ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  />
                </Button>
              </Actions>
            </RequestCard>

            {expandedRequestId === user.id && (
              <CollapsibleContent>
                <p>
                  <strong>{t("name")}:</strong> {user.name}
                </p>
                <p>
                  <strong>{t("email")}:</strong> {user.email}
                </p>
                <p>
                  <strong>{t("phone")}:</strong> {user.telephone}
                </p>
                {user.pdfFiles && user.pdfFiles.length > 0 ? (
                   <>
                     <strong>{t("files")}:</strong>
                     <PdfFileButtons>
                       {user.pdfFiles.map((file) => (
                         <a
                           key={file.id}
                           href="#!"
                           onClick={(e) => {
                             e.preventDefault();
                             openModal(file.url);
                           }}
                           style={{
                             marginRight: "10px",
                             marginTop: "10px",
                             cursor: "pointer",
                            //  color: selectedPdfUrl === file.url ? "#4CAF50" : "#385963",
                             textDecoration: "underline",
                             display: "inline-block",
                           }}
                         >
                           {file.name}
                         </a>
                       ))}
                     </PdfFileButtons>
                   </>
                 ) : (
                   <p>{t("noPdfFiles")}</p>
                 )}
              </CollapsibleContent>
            )}
          </div>
        ))
      )}

    <ModalOverlay visible={modalVisible} onClick={closeModal}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <PdfIframe src={modalPdfUrl} title="PDF Fullscreen Preview" />
      </ModalContent>
    </ModalOverlay>



    </Container>
  );
};


export default ProviderRequests;